var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-container",
        {
          staticClass: "pt-3",
          staticStyle: { "max-height": "95vh", color: "rgb(238, 238, 238)" },
        },
        [
          _vm._l(_vm.projects, function (p) {
            return _c(
              "div",
              { key: p.name, staticClass: "menu" },
              [
                _vm.globalIsUserAllowed(p.module_name)
                  ? _c(
                      "b-row",
                      { attrs: { "align-v": "center" } },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "optn pl-2",
                            on: {
                              click: function ($event) {
                                return _vm.loadLeftNavProject(p)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "project" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(p.name) +
                                  "\n          "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "clickable",
                            attrs: { cols: "1" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleProject(p.name)
                              },
                            },
                          },
                          [
                            _vm.projectsWithSubButtons.includes(p.name)
                              ? _c("fa", {
                                  staticStyle: { float: "left" },
                                  attrs: {
                                    icon: [
                                      "fas",
                                      _vm.getProjectToggle(p)
                                        ? "caret-up"
                                        : "caret-down",
                                    ],
                                    size: "lg",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                p.name == "Acquisitions" && _vm.dprToggle
                  ? _c(
                      "div",
                      { staticClass: "submenu" },
                      [
                        _vm.globalIsUserAllowed("DPR")
                          ? _c(
                              "b-row",
                              { attrs: { id: "dPREntryManagerRow" } },
                              [
                                _c("b-col", { staticClass: "item" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "sub-project",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "loadProject",
                                            "Daily Productivity Report"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Daily Productivity Report\n            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.globalIsUserAllowed("Entry_Manager")
                          ? _c(
                              "b-row",
                              { attrs: { id: "dPREntryManagerRow" } },
                              [
                                _c("b-col", { staticClass: "item" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "sub-project",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "initEntryManager",
                                            _vm.isAdmin
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Entry Manager\n            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.globalIsUserAllowed("DPR_Reports")
                          ? _c(
                              "b-row",
                              [
                                _c("b-col", { staticClass: "item" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "sub-project",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("initReportConsole")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Reports\n            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.globalIsUserAllowed("DPR_Admin_Console")
                          ? _c(
                              "b-row",
                              [
                                _c("b-col", { staticClass: "item" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "sub-project",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("initAdminConsole")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Admin Console\n            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.globalIsUserAllowed("GTP_Tracking")
                          ? _c(
                              "b-row",
                              [
                                _c("b-col", { staticClass: "item" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "sub-project",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("initGTPModal")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              GTP Tracking\n            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.globalIsUserAllowed("GTP_Report")
                          ? _c(
                              "b-row",
                              [
                                _c("b-col", { staticClass: "item" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "sub-project",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("initGTPReportModal")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              GTP Report\n            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.globalIsUserAllowed("Field_Images")
                          ? _c(
                              "b-row",
                              [
                                _c("b-col", { staticClass: "item" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "sub-project",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("initImageCarousel")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Field Images\n            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.globalIsUserAllowed("EOD")
                          ? _c(
                              "b-row",
                              [
                                _c("b-col", { staticClass: "item" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "sub-project",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "initEODFieldReviewCarousel"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              EOD Field Trail Review \n            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Hard_Drive_Tracking_Menu")
            ? _c(
                "div",
                { staticClass: "menu" },
                [
                  _c(
                    "b-row",
                    {
                      attrs: { "align-v": "center" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleProject("Hard Drive Tracking Menu")
                        },
                      },
                    },
                    [
                      _c("b-col", { staticClass: "optn pl-2" }, [
                        _c("div", { staticClass: "project" }, [
                          _vm._v(
                            "\n            Hard Drive Tracking Menu\n          "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "clickable", attrs: { cols: "1" } },
                        [
                          _c("fa", {
                            staticStyle: { float: "left" },
                            attrs: {
                              icon: [
                                "fas",
                                _vm.getProjectToggle("Hard Drive Tracking Menu")
                                  ? "caret-up"
                                  : "caret-down",
                              ],
                              size: "lg",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hdtToggle
                    ? _c(
                        "div",
                        { staticClass: "submenu" },
                        [
                          _vm.globalIsUserAllowed("Hard_Drive_Tracking")
                            ? _c(
                                "b-row",
                                [
                                  _c("b-col", { staticClass: "item" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "sub-project",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit(
                                              "loadProject",
                                              "Hard Drive Tracking"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              Hard Drive Tracking\n            "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.globalIsUserAllowed("HDT_Admin_Console")
                            ? _c(
                                "b-row",
                                [
                                  _c("b-col", { staticClass: "item" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "sub-project",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit(
                                              "initHDTAdminConsole"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              Admin Console\n            "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Vehicles")
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "project-row-padding align-items-center menu pb-2",
                  },
                  [
                    _c("div", { staticClass: "clickable col-1" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "project-name-padding col" }, [
                      _c(
                        "div",
                        {
                          staticClass: "project",
                          on: {
                            click: function ($event) {
                              return _vm.fleetioVehiclesModal()
                            },
                          },
                        },
                        [_vm._v("\n            Vehicle Status\n          ")]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Work_Management_System")
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "project-row-padding align-items-center menu pb-2",
                  },
                  [
                    _c("div", { staticClass: "clickable col-1" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "project-name-padding col" }, [
                      _c(
                        "div",
                        {
                          staticClass: "project",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("initWmsModal")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            Work Management System\n          "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("WCL")
            ? _c(
                "div",
                {
                  staticClass: "menu menu-last",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("initWCL")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "project-row-padding align-items-center pb-2",
                    },
                    [
                      _c("div", { staticClass: "clickable col-1" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "project-name-padding col" }, [
                        _c("div", { staticClass: "project" }, [_vm._v("WCL")]),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Data_Tools")
            ? _c(
                "div",
                {
                  staticClass: "menu menu-last",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("initDataTool")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "project-row-padding align-items-center pb-2",
                    },
                    [
                      _c("div", { staticClass: "clickable col-1" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "project-name-padding col" }, [
                        _c("div", { staticClass: "project" }, [
                          _vm._v("Data Tools "),
                        ]),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Sales")
            ? _c(
                "div",
                {
                  staticClass: "menu menu-last",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("initSales")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "project-row-padding align-items-center pb-2",
                    },
                    [
                      _c("div", { staticClass: "clickable col-1" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "project-name-padding col" }, [
                        _c("div", { staticClass: "project" }, [
                          _vm._v("Sales"),
                        ]),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Spatial_Intelligence")
            ? _c(
                "div",
                {
                  staticClass: "menu menu-last",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("initSI")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "project-row-padding align-items-center pb-2",
                    },
                    [
                      _c("div", { staticClass: "clickable col-1" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "project-name-padding col" }, [
                        _c("div", { staticClass: "project" }, [
                          _vm._v("Spatial Intelligence"),
                        ]),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.homeScreenComponents &&
          _vm.ushrLayersVisible &&
          _vm.isUshrUser &&
          _vm.globalIsUserAllowed("DMP_Layers")
            ? _c(
                "div",
                {
                  staticClass: "menu menu-last",
                  on: { click: _vm.toggleUshrLayers },
                },
                [
                  _c(
                    "b-row",
                    {
                      staticClass: "project-row-padding pb-2",
                      attrs: { "align-v": "center" },
                    },
                    [
                      _c("b-col", { staticClass: "project-name-padding" }, [
                        _c("div", { staticClass: "project" }, [
                          _vm._v("DMP Layers"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "clickable", attrs: { cols: "1" } },
                        [
                          _c("fa", {
                            staticStyle: { float: "left" },
                            attrs: {
                              icon: [
                                "fas",
                                _vm.ushrLayersToggle
                                  ? "caret-up"
                                  : "caret-down",
                              ],
                              size: "lg",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.homeScreenComponents &&
          _vm.ushrLayersVisible &&
          _vm.ushrLayersToggle &&
          _vm.isUshrUser &&
          _vm.globalIsUserAllowed("DMP_Layers")
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    { attrs: { "align-v": "center" } },
                    [
                      _c("MMP_DynamicLayerList", {
                        staticClass:
                          "card-body dynamic-layer-list scroll-Container menu-last",
                        attrs: {
                          customerProjectId: _vm.customerProjectId,
                          map: _vm.map,
                          mmp_layersObj: _vm.mmp_layersObj,
                          showUSHRLayers: _vm.ushrLayersVisible,
                          spinnerManager: _vm.spinnerManager,
                          ushrLayersButtonsCtrl: _vm.ushrLayersButtonsCtrl,
                          ushrLayersToggle: _vm.ushrLayersToggle,
                          zoomEnded: _vm.zoomEnded,
                          zoomLevelCap: _vm.zoomLevelCap,
                          showLidarPanel: _vm.showLidarPanel,
                          baseMapsOpen: _vm.baseMapsOpen,
                          extentsOpen: _vm.extentsOpen,
                        },
                        on: {
                          layerButtonsChanged: function ($event) {
                            return _vm.$emit("layerButtonsChanged", $event)
                          },
                          toggleLayers: function ($event) {
                            return _vm.toggleUshrLayers()
                          },
                          toggleLayerVisibility: function ($event) {
                            return _vm.$emit("toggleLayerVisibility", $event)
                          },
                          toTopOfList: function ($event) {
                            return _vm.$emit("toTopOfList", $event)
                          },
                          updateZoomEnded: function ($event) {
                            return _vm.$emit("updateZoomEnded", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.homeScreenComponents &&
          !_vm.ushrLayersVisible &&
          _vm.globalIsUserAllowed("Customer_Layers")
            ? _c(
                "div",
                {
                  staticClass: "menu menu-last",
                  on: { click: _vm.toggleUshrLayers },
                },
                [
                  _c(
                    "b-row",
                    {
                      staticClass: "project-row-padding pb-2",
                      attrs: { "align-v": "center" },
                    },
                    [
                      _c("b-col", { staticClass: "project-name-padding" }, [
                        _c("div", { staticClass: "project" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.user.role.replace("User", "")) +
                              " Layers\n          "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "clickable", attrs: { cols: "1" } },
                        [
                          _c("fa", {
                            attrs: {
                              icon: [
                                "fas",
                                _vm.ushrLayersToggle
                                  ? "caret-up"
                                  : "caret-down",
                              ],
                              size: "lg",
                              title: _vm.ushrLayersToggle
                                ? "Collapse"
                                : "Expand",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.homeScreenComponents &&
          !_vm.ushrLayersVisible &&
          _vm.ushrLayersToggle
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    { attrs: { "align-v": "center" } },
                    [
                      _c("MMP_DynamicLayerList", {
                        staticClass:
                          "card-body dynamic-layer-list scroll-Container menu-last",
                        attrs: {
                          customerLayersButtonsCtrl:
                            _vm.customerLayersButtonsCtrl,
                          customerLayersToggle: _vm.ushrLayersToggle,
                          customerProjectId: _vm.customerProjectId,
                          cust_layersObj: _vm.cust_layersObj,
                          map: _vm.map,
                          mmp_layersObj: _vm.mmp_layersObj,
                          showCustomerLayers: true,
                          spinnerManager: _vm.spinnerManager,
                          zoomEnded: _vm.zoomEnded,
                          zoomLevelCap: _vm.zoomLevelCap,
                          showLidarPanel: _vm.showLidarPanel,
                          baseMapsOpen: _vm.baseMapsOpen,
                          extentsOpen: _vm.extentsOpen,
                        },
                        on: {
                          layerButtonsChanged: function ($event) {
                            return _vm.$emit("layerButtonsChanged", $event)
                          },
                          toggleLayers: function ($event) {
                            return _vm.toggleUshrLayers()
                          },
                          toggleLayerVisibility: function ($event) {
                            return _vm.$emit("toggleLayerVisibility", $event)
                          },
                          toTopOfList: function ($event) {
                            return _vm.$emit("toTopOfList", $event)
                          },
                          updateZoomEnded: function ($event) {
                            return _vm.$emit("updateZoomEnded", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }